import React from 'react';
import {DmsTab} from 'Components';
import {hashHistory} from 'react-router';
import {Form, Input, Row, Col, Table, Checkbox, Button, Radio, Select, message} from 'antd';
import {peopleDetail} from '../../service/people';
const FormItem = Form.Item;
const Option = Select.Option;


class PeopleDetail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			detailId: this.props.params.detailId,
			opts: ['人员详情'],
			detail: {},
			channelNames:'',
			organization: []
		};
		this.getDetail = this.getDetail.bind(this);
	}
	
	componentWillMount() {
		this.getDetail();
	}
	
	getDetail() {
		const self =this;
		peopleDetail({id: parseInt(this.state.detailId, 0)}).then(result => {
			if (result.status) {
				result.data.plainPassword='******';
				//联系方式
				let data = result.data;
				if(data.channelList!=null&&data.channelList.length>0){
					let str = '     ';
                    data.channelList.forEach(x => {
            			str+=x.name+`; `
                    });
                    // console.log(str)
                    self.setState({
						channelNames:str,
					})

                }


				if (result.data.contactInfoList!=null&&result.data.contactInfoList.length > 0) {
					var contactArr = result.data.contactInfoList;
					for (var i = 0; i < contactArr.length; i++) {
						if (contactArr[i].type === 1) {
							result.data.phoneId = contactArr[i].id;
							result.data.phone = contactArr[i].content;
						}
						if (contactArr[i].type === 2) {
							result.data.telId = contactArr[i].id;
							result.data.tel = contactArr[i].content;
						}
						if (contactArr[i].type === 3) {
							result.data.emailId = contactArr[i].id;
							result.data.email = contactArr[i].content;
						}
					}
				}

				//组织
				if (result.data.employeeOrganizationList!=null&&result.data.employeeOrganizationList.length > 0) {
					var organizationList = result.data.employeeOrganizationList;
					var employeeArr = [];
					for (var e = 0; e < organizationList.length; e++) {
						var employeeObj = {};
						if (organizationList[e].isCharge === 1) {
							employeeObj.isCharge=true;
						} else {
							employeeObj.isCharge=false;
						}
						;
						employeeObj.isMajor = organizationList[e].isMajor;
						if (organizationList[e].isMajor === 1) {
							employeeObj.isMajor = true;
						} else {
							employeeObj.isMajor = false;
						}
						employeeObj.org = organizationList[e].organization;
						employeeObj.job = organizationList[e].post;
						employeeObj.key = e + 1;
						employeeArr.push(employeeObj);
					}
					this.setState({
						detail: result.data,
						organization: employeeArr,
						count: employeeArr.length + 1
					})
				} else {
					this.setState({
						detail: result.data,
						count: 1
					})
				}
			} else {
				message.error(result.message);
			}
		})
	}
	
	cancelHandle() {
		hashHistory.goBack();
	}
	
	//页面跳转
	goView (url) {
		hashHistory.push(url);
	}
	
	render() {
		const {opts, detail,organization,detailId,channelNames} = this.state;
		const {getFieldDecorator} = this.props.form;
		const inputstyle = {
			border: 'none',
			borderBottom: '1px solid #ccc',
			background: '#fff',
			color: '#333'
		}

		return <div className='dms-body'>
					<DmsTab options={opts} defaultKey={0}>
						<Button onClick={this.cancelHandle.bind(this)}>返回</Button>
						<Button icon="edit" onClick={this.goView.bind(this, `/people/add/${detailId}`)}>编辑</Button>
					</DmsTab>
			<div className="dms-table-box" style={{backgroundColor: "#fff"}}>
				<Form layout="horizontal">
					<Row gutter={100}>
						<Col className="gutter-row" span={12}>
							<FormItem label="姓名">
								{getFieldDecorator('name', {
									initialValue: (detail !== null && detail.name) ? detail.name : ''
								})(<Input disabled style={inputstyle}/>)}
							</FormItem>
						</Col>
						<Col className="gutter-row" span={12}>
							<FormItem label="性别">
								{getFieldDecorator('sex', {
									initialValue: (detail !== null && detail.sex===0) ? '0' : '1',
								})(<Select disabled>
									<Option value='1'>男</Option>
									<Option value='0'>女</Option>
								</Select>)}
							</FormItem>
						</Col>
					</Row>
					
					<Row gutter={100}>
						<Col className="gutter-row" span={12}>
							<FormItem label="状态">
								{getFieldDecorator('status', {
									initialValue: (detail !== null && detail.status===0) ? '0' : '1',
								})(<Select disabled>
									<Option value='1'>在职</Option>
									<Option value='0'>离职</Option>
								</Select>)}
							</FormItem>
						</Col>
						<Col className="gutter-row" span={12}>
							<FormItem label="邮件">
								{getFieldDecorator('email', {
									initialValue: (detail !== null && detail.email) ? detail.email : ''
								})(<Input disabled style={inputstyle}/>)}
							</FormItem>
						</Col>
					</Row>
					
					<Row gutter={100}>
						<Col className="gutter-row" span={12}>
							<FormItem label="手机">
								{getFieldDecorator('phone', {
									initialValue: (detail !== null && detail.phone) ? detail.phone : ''
								})(<Input disabled style={inputstyle}/>)}
							</FormItem>
						</Col>
						<Col className="gutter-row" span={12}>
							<FormItem label="座机">
								{getFieldDecorator('tel', {
									initialValue: (detail !== null && detail.tel) ? detail.tel : '',
								})(<Input disabled style={inputstyle}/>)}
							</FormItem>
						</Col>
					</Row>
					
					<Row gutter={100}>
						<Col className="gutter-row" span={12}>
							<FormItem label="账号">
								{getFieldDecorator('account', {
									initialValue: (detail !== null && detail.account) ? detail.account : ''
								})(<Input disabled style={inputstyle}/>)}
							</FormItem>
						</Col>
						<Col className="gutter-row" span={12}>
							<FormItem label="密码">
								{getFieldDecorator('plainPassword', {
									initialValue: (detail !== null && detail.plainPassword) ? detail.plainPassword : ''
								})(<Input disabled style={inputstyle}/>)}
							</FormItem>
						</Col>
					</Row>
                    <Row gutter={16}>
                        <Col className="gutter-row" span={24}>
                            <FormItem label="渠道" hasFeedback>
                                {getFieldDecorator('channelList', {
                                    initialValue: channelNames,
								})(<div>{channelNames}</div>)}
                            </FormItem>
                        </Col>
                    </Row>
				
				</Form>
			</div>
		</div>
	}
}
export default Form.create()(PeopleDetail)




// WEBPACK FOOTER //
// ./src/routes/people/detail.js